// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"0521966f","149":"e875eafd","213":"f4980d88","239":"4a41bfb1","622":"909ece56"}[chunkId] + ".chunk.js";
};